function useSessionStorage(key) {
    function setSessionStorage(value) {
        try {
            window.sessionStorage.setItem(key, JSON.stringify(value));
        } catch(e) {
            throw new Error("Stringify failed useSessionStorage value");
        }
    }

    function getSessionStorage() {
        try {
            return JSON.parse(window.sessionStorage.getItem(key));
        } catch(e) {
            return window.sessionStorage.getItem(key);
        }
    }

    function isHas() {
        return getSessionStorage() ? true : false;
    }

    function clearItem() {
        window.sessionStorage.removeItem(key);
    }

    function clearAll() {
        window.sessionStorage.clear();
    }

    function clearWhenReloadOrExit() {
        window.addEventListener("beforeunload", () => {
            clearItem();
        });
    }

    return {
        setSessionStorage,
        getSessionStorage,
        isHas,
        clearItem,
        clearAll,
        clearWhenReloadOrExit,
    };
}

export default useSessionStorage;



// WEBPACK FOOTER //
// ./src/core/helpers/useSessionStorage.js